/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * DriverStopActionDtoBase
 * auto generated base class for the model DriverStopActionDtoModel.
 */
export const DriverStopActionDtoModelBase = ModelBase
  .named('DriverStopActionDto')
  .props({
    __typename: types.optional(types.literal("DriverStopActionDto"), "DriverStopActionDto"),
    actionUuid: types.identifier,
    actionName: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class DriverStopActionDtoModelSelector extends QueryBuilder {
  get actionUuid() { return this.__attr(`actionUuid`) }
  get actionName() { return this.__attr(`actionName`) }
}
export function selectFromDriverStopActionDto() {
  return new DriverStopActionDtoModelSelector()
}

export const driverStopActionDtoModelPrimitives = selectFromDriverStopActionDto().actionUuid.actionName
